import { useTranslation } from 'react-i18next';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('category.title')}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            {t('category.subtitle')}
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <CategoryDropdown />
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group overflow-hidden rounded-lg border border-background-200 bg-white transition-colors hover:border-primary-300"
            >
              <div className="h-36 w-full overflow-hidden md:h-40">
                <img
                  src={cat.image}
                  alt={t(`category.${cat.key}`)}
                  title={`${t(`category.${cat.key}`)} — USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between px-3 py-2.5">
                <span className="whitespace-nowrap text-sm font-semibold text-foreground-800">
                  {t(`category.${cat.key}`)}
                </span>
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-center gap-3 rounded-lg bg-primary-50 p-6 sm:flex-row sm:gap-4">
          <span className="text-center text-sm font-semibold text-foreground-800">
            {t('cta.title')}
          </span>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              {t('cta.spread')}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
            >
              {t('cta.buyNow')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}